import { render, staticRenderFns } from "./headTabs.vue?vue&type=template&id=12716107&scoped=true"
import script from "./headTabs.vue?vue&type=script&lang=js"
export * from "./headTabs.vue?vue&type=script&lang=js"
import style0 from "./headTabs.vue?vue&type=style&index=0&id=12716107&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12716107",
  null
  
)

export default component.exports